import { Beneficiary, BeneficiaryResponseDTO } from '../entities';

const beneficiaryResponseDTOToBeneficiaryAdapter = (data: BeneficiaryResponseDTO): Beneficiary => {
  if (!data.body) {
    throw new Error('Error');
  }

  return new Beneficiary(
    data.body.id,
    data.body.name,
    data.body.iban,
    data.body.bankName,
    data.body.bic,
    data.body.creditorFullName,
    data.body.bankCountry,
    data.body.bankCity,
    data.body.bankAddress,
    data.body.debitCurrency,
    data.body.debitCurrDescription,
    data.body.ecommbx,
    data.body?.beneficiaryCity,
    data.body?.beneficiaryAddress,
    data.body?.beneficiaryCountry,
  );
};

export { beneficiaryResponseDTOToBeneficiaryAdapter };
